// Дзеркало Prisma enum Role. Ролі користувачів (D17, SPEC розд. 5). GUEST — без входу (опублікований розклад).
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const Role = {
    SYSADMIN: 'SYSADMIN',
    SCHEDULE_ADMIN: 'SCHEDULE_ADMIN',
    ACADEMIC_OFFICE: 'ACADEMIC_OFFICE',
    FACULTY: 'FACULTY',
    DEPARTMENT: 'DEPARTMENT',
    TEACHER: 'TEACHER',
    STUDENT: 'STUDENT',
    GUEST: 'GUEST',
};
/** Значення в порядку оголошення в схемі. */
export const ROLE_VALUES = ['SYSADMIN', 'SCHEDULE_ADMIN', 'ACADEMIC_OFFICE', 'FACULTY', 'DEPARTMENT', 'TEACHER', 'STUDENT', 'GUEST'];
export const ROLE_LABELS = {
    SYSADMIN: 'Системний адміністратор',
    SCHEDULE_ADMIN: 'Адміністратор навчального процесу',
    ACADEMIC_OFFICE: 'Навчальний відділ',
    FACULTY: 'Деканат / факультет',
    DEPARTMENT: 'Кафедра',
    TEACHER: 'Викладач',
    STUDENT: 'Студент',
    GUEST: 'Гість',
};
//# sourceMappingURL=role.js.map